module.exports = __webpack_public_path__ + "media/images/videos/fashion_show-d937add16d29fe868e6667e12745941a.mp4";